import {Tooltip} from 'platform/components';
import {Text} from 'platform/foundation';

import {CustomCatalogueModel} from '../utils/groupUsageByMake';

const MODELS_SHOWN_PER_ROW = 3;

interface ModelFamiliesCellProps {
  models: CustomCatalogueModel[];
}

/** A make can be typed on any number of models; past a few the tail moves into a tooltip. */
export function ModelFamiliesCell(props: ModelFamiliesCellProps) {
  const modelFamilies = props.models.map((model) => model.modelFamily);
  const shown = modelFamilies.slice(0, MODELS_SHOWN_PER_ROW).join(', ');
  const hiddenCount = modelFamilies.length - MODELS_SHOWN_PER_ROW;

  if (hiddenCount <= 0) {
    return <Text size="small">{shown}</Text>;
  }

  return (
    <Tooltip label={modelFamilies.join(', ')} placement="top">
      <Text size="small">{`${shown}, +${hiddenCount}`}</Text>
    </Tooltip>
  );
}
